/* vk-shipping-progress v3 — Vedika AyurVeda
   Eine Zeile unter der Warenkorbsumme: wie viel bis zum Gratisversand fehlt.
   Rechnet mit cart.total_price, also dem Betrag NACH Mengenrabatt — nie mit der
   Zwischensumme davor, sonst verspricht die Zeile etwas, das der Checkout nicht
   hält (3 Calcio + 4 Vata: 83.70 vor Rabatt, 75.33 danach).
   v2: horcht zusätzlich direkt auf die /cart/*.js-Aufrufe, statt sich nur auf
   DOM-Änderungen zu verlassen.
   v3: seit es A- und B-Post zur Auswahl gibt, heißt es «Versand frei mit B-Post.»
   — gratis ist ab CHF 80 nur die B-Post, A-Post kostet dann noch CHF 2.00. */
(function () {
  'use strict';

  var SCHWELLE = 8000;            // Rappen; entspricht CHF 80
  var KLASSE = 'vk-ship';
  var ANKER = '.cart-totals__container';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var laeuft = false, timer = null;

  function chf(rappen) { return 'CHF ' + (rappen / 100).toFixed(2); }

  function satz(total) {
    if (total >= SCHWELLE) return 'Versand frei mit B-Post.';
    return 'Noch ' + chf(SCHWELLE - total) + ' bis zum Gratisversand.';
  }

  function zeichne(total) {
    var anker = document.querySelectorAll(ANKER);
    for (var i = 0; i < anker.length; i++) {
      var a = anker[i];
      var el = a.nextElementSibling;
      if (!el || !el.classList || !el.classList.contains(KLASSE)) el = null;
      if (!total || total <= 0) { if (el) el.remove(); continue; }
      if (!el) {
        el = document.createElement('p');
        el.className = KLASSE;
        el.setAttribute('aria-live', 'polite');
        a.insertAdjacentElement('afterend', el);
      }
      var neu = satz(total);
      if (el.textContent !== neu) el.textContent = neu;
      if (el.classList.contains(KLASSE + '--frei') !== (total >= SCHWELLE)) {
        el.classList.toggle(KLASSE + '--frei', total >= SCHWELLE);
      }
    }
  }

  function hole() {
    if (laeuft || !document.querySelector(ANKER)) return;
    laeuft = true;
    fetch('/cart.js', { headers: { accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) zeichne(c.total_price); })
      .catch(function () {})
      .then(function () { laeuft = false; });
  }

  function angestossen(verzug) {
    clearTimeout(timer);
    timer = setTimeout(hole, verzug || 150);
  }

  // Warenkorb-Aufrufe abhören — zuverlässiger als auf das DOM zu warten.
  function horchen() {
    var f = window.fetch;
    if (typeof f === 'function') {
      window.fetch = function (eingabe, optionen) {
        var url = '';
        try { url = typeof eingabe === 'string' ? eingabe : (eingabe && eingabe.url) || ''; } catch (e) {}
        var treffer = CART_RE.test(url);
        var p = f.apply(this, arguments);
        if (treffer && p && p.then) p.then(function () { angestossen(60); }, function () {});
        return p;
      };
    }
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (methode, url) {
      if (CART_RE.test(String(url))) {
        this.addEventListener('loadend', function () { angestossen(60); });
      }
      return open.apply(this, arguments);
    };
  }

  function start() {
    hole();
    horchen();
    if (window.MutationObserver) {
      new MutationObserver(function () { angestossen(250); })
        .observe(document.body, { childList: true, subtree: true });
    }
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (n) {
      document.addEventListener(n, function () { angestossen(60); });
    });
    window.addEventListener('pageshow', hole);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
